export default {
  settings: Object.freeze({POSITION_LOCAL_STORAGE_KEY: 'services-group-position'}),
}
